export default __webpack_public_path__ + "static/media/icon_file_tag.99d599ad.svg";